import { z } from "zod";
import { EntitySchema } from "./Entity";
import { CodeSchema } from "./Codes";

const WaiverSchema = z.object({
  waiverId: z.string().nullable(),
  projectId: z.string(),
  ordinal: z.number(),
  dateStamp: z.coerce.date(),
  waiverProcessor: EntitySchema.nullable(),
  approved: z.boolean(),
  waiverApprover: z.string().nullable(),
  waiverDescription: CodeSchema,
});

const SimpleWaiverSchema = z.object({
  waiverId: z.number().nullable(),
  projectId: z.string(),
  description: z.string(),
  amount: z.number(),
  conLienWaiver: z.boolean().nullable(),
  uncLienWaiver: z.boolean().nullable(),
  notes: z.string(),
});

const defaultZero = (x: number | null) => x ?? 0;

const TabbedWaiverSchema = z.object({
  waiverId: z.number().nullable(),
  tabId: z.string().nullable(),
  contractAmount: z.number().nullable().transform(defaultZero),
  adjustedContractAmount: z.number().nullable().transform(defaultZero),
  dateOrPeriodThrough: z.coerce.date().nullable(),
  netAmountBilled: z.number().nullable().transform(defaultZero),
  gcpayApp: z.number(),
  subPayAppNum: z.string().nullable(),
  conditional: z.number().nullable().transform(defaultZero),
  unconditional: z.number().nullable().transform(defaultZero),
  note: z.string(),
  totalPaidToDate: z.number(),
});

const TabbedWaiverTabSchema = z.object({
  tabId: z.string().nullable(),
  projectId: z.string(),
  description: z.string(),
  ordinal: z.number(),
  tabbedWaivers: z.array(TabbedWaiverSchema),
});

export const WaiversSchema = z.object({
  waivers: z.array(WaiverSchema),
  simpleWaivers: z.array(SimpleWaiverSchema),
  tabbedWaiverTabs: z.array(TabbedWaiverTabSchema),
  waiverDescriptions: z.array(CodeSchema),
});

export type Waiver = z.infer<typeof WaiverSchema>;
export type SimpleWaiver = z.infer<typeof SimpleWaiverSchema>;
export type TabbedWaiver = z.infer<typeof TabbedWaiverSchema>;
export type TabbedWaiverTab = z.infer<typeof TabbedWaiverTabSchema>;
export type Waivers = z.infer<typeof WaiversSchema>;
